/*******************************************************************************
select Radio Button In row
selects a radio butt and deseslects another in a radio row
*******************************************************************************/

// Selects a custom radio button (horizontal)
export default function selectRadioButtonInRow(e) {
	var $rb = $(e.currentTarget);
	var rbName = $rb.data('name');

	// De-select all the radio buttons with the same name
	$('.radio-box[data-name="' + rbName + '"]').removeClass('radio-box-sel').prop('checked',false);

	// Select the box that was clicked on
	$rb.addClass('radio-box-sel');
	$rb.next('.radio-box-real').prop('checked',true).trigger('change');
}
